module.exports = __webpack_public_path__ + "img/illust4-2x.62e94646.png";